import React, { FC, createContext, useMemo, useContext, useState, ReactNode } from "react";
import { AppShellType } from "./appShellType";
import headerJson from "../../../../layout-module/layout-configuration/header/ts/header-config.json";

const appShellContext = createContext<AppShellType | null>(null);

// ===== Provider =====
export const AppShellProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [header, setHeader] = useState(headerJson.header);

  const value = useMemo(
    () => ({
      header,
      setHeader,
    }),
    [header]
  );

  return (
    <appShellContext.Provider value={value}>
      {children}
    </appShellContext.Provider>
  );
};

// ===== Custom hook =====
export const useAppShellCustomState = () => {
  const context = useContext(appShellContext);
  if (!context) throw new Error("useAppShellCustomState must be used inside AppShellProvider");
  return context;
};
